$( document ).ready(function() {
  
  $('.open-popup-link').magnificPopup({
    type: 'inline',
    midClick: true,
    mainClass: 'mfp-fade'
  });

  // if($('body').hasClass('template-product')){
  //   var isALARendered;
  //   function ALAcheck() {
  //     isALARendered = setInterval(function () {
  //       customALA()
  //     }, 200);
  //   }
  //   ALAcheck();
  //   function customALA() {
  //   var selector = $('lb-upsell-product-page-addon');
  //     if(selector.length > 0) {
  //       clearInterval(isALARendered);
  //       $('.button.atc-btn.medium-btn:first').show();
  //     }  else{
  //       $('.button.atc-btn.medium-btn:first').hide();
  //     }
  //   }
  // }



$('.video-poup-btn').each(function(){
  $(this).on('click',function(){
    $(".video-modal-custom").addClass('modal-open');
    $("body").addClass('video-modal-open');

    var id_att = $(this).attr('data-id');
    $('.video-modal-custom .video-popup-content').addClass('hidden');
    // $('.video-modal-custom .video-popup-content[data-id="'+id_att+'"]').removeClass('hidden');
 var currentVideo = $('.video-modal-custom .video-popup-content[data-id="' + id_att + '"]');
        currentVideo.removeClass('hidden');
    // Handle YouTube iframe
        var iframe = currentVideo.find("iframe");
        if (iframe.length) {
            var src = iframe.attr("src").replace("&mute=1", ""); // Remove mute parameter
            iframe.attr("src", src); // Reload iframe with unmuted sound
        }

        // Handle HTML5 video
        var video = currentVideo.find("video");
        if (video.length) {
            video[0].muted = false; // Unmute video
            video[0].play(); // Ensure video plays
        }
    
  });
});
  
//   $(".video-poup-btn").on('click', function(){
//     $(".video-modal-custom").addClass('modal-open');
//     $("body").addClass('video-modal-open');
// });
  $(".close-video-modal").on('click', function(){
    $(".video-modal-custom").removeClass('modal-open');
    $("body").removeClass('video-modal-open');

     // Mute all videos & stop YouTube playback
        $(".video-modal-custom .video-popup-content").each(function () {
            var iframe = $(this).find("iframe");
            if (iframe.length) {
                var src = iframe.attr("src");
                if (!src.includes("&mute=1")) {
                    iframe.attr("src", src + "&mute=1"); // Add mute when closing
                }
            }

            var video = $(this).find("video");
            if (video.length) {
                video[0].muted = true; // Mute HTML5 video
                video[0].pause(); // Pause video
            }
        });
});

//   $(".video-poup-btn.second").on('click', function(){
//     $(".video-modal-custom").addClass('modal-open');
//     $("body").addClass('video-modal-open');
// });
//   $(".close-video-modal").on('click', function(){
//     $(".video-modal-custom").removeClass('modal-open');
//     $("body").removeClass('video-modal-open');
// });
  
  
});


